import {
    GET_MERCHANT_AVAILABLE_TERMINAL_FAILED, GET_MERCHANT_AVAILABLE_TERMINAL_LOADING, GET_MERCHANT_AVAILABLE_TERMINAL_SUCCESS, REMOVE_MERCHANT_AVAILABLE_TERMINAL
} from "../types";

const initialState = {
    terminals: null,
    loading: null,
    error: null,
};

export const getMerchantAvailableTerminalReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
) => {
    switch (action.type) {
        case GET_MERCHANT_AVAILABLE_TERMINAL_LOADING:
            return {
                ...state,
                loading: action.loading,
                error: null,
            };
        case GET_MERCHANT_AVAILABLE_TERMINAL_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                terminals: action.payload,
            };
        case GET_MERCHANT_AVAILABLE_TERMINAL_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case REMOVE_MERCHANT_AVAILABLE_TERMINAL:
            return {
                terminals: null,
                loading: null,
                error: null,
            };

        default:
            return state;
    }
};
